import { registerPrimitives } from "./primitives";
import { registerFunctions } from "./functions";
import { registerActions } from "./actions";
import { registerPortableUIs } from "./portable-renderers";
import { registerFetchers } from "./fetchers";
import { registerGlideFunctions } from "./functions-glide";
import { registerDeserializable } from "./deserialization";
import { registerGlidePrimitives } from "./primitives-glide";

export function registerPortableComponents() {
    registerPrimitives(registerDeserializable);
    registerGlidePrimitives();
    registerFunctions();
    registerGlideFunctions();
    registerActions();
    registerFetchers();
    registerPortableUIs();
}
